<style lang="scss" scoped>

</style>
<template>

</template>
<script>
    export default {
        mounted() {
            this.$router.push({
                name: 'dashboard'
            })
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/private/components/pages/404.vue